import { useNavigate, useLocation } from "react-router-dom";

export function MobileBottomNav({ items, basePath }) {
    const navigate = useNavigate();
    const { hash } = useLocation();
    const current = (hash || "#overview").replace("#", "");

    return (
        <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-xl border-t border-gray-100 shadow-[0_-8px_30px_rgba(0,0,0,0.06)]" data-testid="mobile-bottom-nav">
            <div className="flex items-stretch justify-around safe-area-inset-bottom">
                {items.map((it) => {
                    const isActive = current === it.id;
                    const Icon = it.icon;
                    return (
                        <button
                            key={it.id}
                            onClick={() => navigate(`${basePath}#${it.id}`)}
                            className={`flex-1 flex flex-col items-center gap-1 py-2.5 transition-colors ${
                                isActive ? "text-[var(--medx-red)]" : "text-gray-500 hover:text-[var(--medx-orange)]"
                            }`}
                            data-testid={`mobile-nav-${it.id}`}
                        >
                            <div className={`w-9 h-9 rounded-full grid place-items-center transition-all ${isActive ? "bg-gradient-to-br from-[var(--medx-red)]/15 to-[var(--medx-orange)]/15" : ""}`}>
                                <Icon className="w-5 h-5" />
                            </div>
                            <span className="text-[10px] font-medium leading-none">{it.label}</span>
                            {isActive && <span className="absolute bottom-0 w-8 h-0.5 bg-[var(--medx-red)] rounded-full" />}
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
